import { inject, observer } from "mobx-react";

import Default from "./Default";
// import AB_1805AnimationFortune_v2 from "./AB_1805_v2"; 15.01.26 еще не запущен
// import AB_1805AnimationFortune_v3 from "./AB_1805_v3";
// import AB_1805AnimationFortune_v4 from "./AB_1805_v4";
// import AB_1805AnimationFortune_v5 from "./AB_1805_v5";
// import AB_1805AnimationFortune_v6 from "./AB_1805_v6";
// import AB_1805AnimationFortune_v7 from "./AB_1805_v7";
// import AB_1805AnimationFortune_v8 from "./AB_1805_v8";
// import AB_1805AnimationFortune_v9 from "./AB_1805_v9";

const FortuneOffline = inject("mainStore")(
    observer(({ mainStore }) => {
        // const init = mainStore.getMainStore("init");

        let Specified = Default;

        // const tests = init?.data?._ab_m || {};

        // for (const testKey in tests) {
        //     const testData = tests[testKey];

        //     if (!abTest[testKey]) continue;

        //     const ver = testData?._d?.colorHeader;

        //     if (abTest[testKey][ver]) {
        //         Specified = abTest[testKey][ver];
        //         break;
        //     }
        // }

        return <Specified />;
    }),
);

export default FortuneOffline;

// const AB_1805 = {
//     v2: AB_1805AnimationFortune_v2,
//     v3: AB_1805AnimationFortune_v3,
//     v4: AB_1805AnimationFortune_v4,
//     v5: AB_1805AnimationFortune_v5,
//     v6: AB_1805AnimationFortune_v6,
//     v7: AB_1805AnimationFortune_v7,
//     v8: AB_1805AnimationFortune_v8,
//     v9: AB_1805AnimationFortune_v9,
// };

// const abTest = {
//     "dev_1805_19.11.2025": AB_1805,
// };
